import api from '../../api/api.js'
import order from '../../api/moudles/order.js'
import mygoods from '../../api/moudles/mygoods.js'
import utils from '../../utils/utils.js'

import { Message } from 'element-ui'
import i18n from '../../i18n/i18n.js'



import {
  SET_ORDER_LIST,
  SET_ORDER_FINISH,
  READY_TO_SHIP,
  SET_ORDER_UNPAID,
  ALL_ORDERS,
  CANCELLED,
  TO_RETURN,
  TO_CONFIRM_RECEIVE,
  GET_UNPROCESS_ORDER,
  SET_ORDERLIST_NULL,
  GET_DEAL_OREDR,
  GET_AUDITED_ORDER,
  DELET_UNPROCESS_ORDER,
  GET_DEAL_ORDER,
  GET_COMPLETEED_ORDER,
  CHOOSE_SHOPID,
  AUDITOR_ORDER_CHOOSE,
  COMPLETED_ORDER_CHOOSE,
  CHOOSE_SHOPID_TTP,
  CHOOSE_SHOPID_OOP,
  GO_TO_SEARCH,
  GO_TO_SEARCH_DEALOURDER,
  GO_TO_SEARCH_PENDING,
  SUCCESS_GET_DATA,
  SUCCESS_GET_DATA_OPEN,
  GET_QUESTION_ORDER,
  GO_TO_SEARCH_QUESTION,
  QUESTION_ORDER_CHOOSE,
  PENDING_TOTAL_COUNT,
  UNPROCESS_TOTAL_COUNT,
  SHIPPED_TOTAL_COUNT,
  PROBLEM_TOTAL_COUNT,
  RETURN_TOTAL_ORDER,
  IN_CANCEL_TOTAL_ORDER,
  SET_ITEM_CHECKED_FALSE,
  SET_ITEM_CHECKED_TRUE,                     
  SET_PICKING_LIST,
  SET_PICKING_NULL,
  ININ_TRACKING_NO,
  GET_ORDER_NUPRINT,
  GET_RETURN_ORDER,
  GET_RETURN_CHIRD_TOTAL_14,
  GET_RETURN_CHIRD_TOTAL_17,
  GET_RETURN_CHIRD_TOTAL_15,
  GET_RETURN_CHIRD_TOTAL_16,
  GET_RETURN_CHIRD_TOTAL_18,
  GET_RETURN_CHIRD_TOTAL_20,
  GET_RETURN_CHIRD_TOTAL_22,
  GET_RETURN_CHIRD_TOTAL_21,
  GET_STORE_ALERDAY_PRINT,
  GET_RETURN_CHIRD_TOTAL_23,
  GET_LOGISTICS_INFO,
  GET_CANCEL_TOTAL_24,
  GET_CANCEL_TOTAL_25,
  GET_CANCEL_TOTAL_26,
  GET_CANCEL_TOTAL_27,
  GET_CANCEL_TOTAL_28,
  GET_CANCEL_TOTAL_29,
  GET_RETURN_MANAGEMTNT,
  GET_TTP,
  GET_TTP_PPO,
  SET_FLAGS,
  UPDATE_ALLORDERLIST


  
} from '../mutation-types'
import { resolve } from 'path'

const state = () => ({
  deletReivewData: false,
  isSuccess:true,
  allorderList:[],
  fileterOrder:[],
  unprocessOrder:[], //未审核订单原始数据
  ax_unprocessOrder:[], //未审核订单
  dealOrder:[], //已处理订单数据
  ax_dealOrder:[], //已处理订单渲染数据
  auditedOrderList:[],  //待处理的数据
  ax_auditedOrderList:[],//待处理订单渲染数据
  quesetionOrderList:[],//问题订单数据
  ax_quesetionOrderList:[],//问题订单渲染数据
  completedorder:[], //已发货订单
  pendingorderCounts:0, //待审核订单总数
  unprocessedorderCounts:0, //待处理订单总数
  shippedorderCounts:0, //已发货订单总数
  problemorderCounts:0, //取消订单总数
  returnorderCounts:0,//退货订单总数
  inCancelCounts:0,//申请取消中订单总数
  applicationCounts:0,
  rulingCounts:0,//裁决中订单总数
  acceptedCounts:0,//已接受退货总数
  cancelCounts:0,//取消退货
  returnCounts:0,//退货中
  verifiedCounts:0,//卖家已核实的退货
  disputeCounts:0,//争议订单
  returnedCounts:0,//已退货
  closedCounts:0,//已关闭
  picklist:[],
  dialogVisible_04:false,
  returnList:[],
  LogisticsInfo:{},
  deliverfailedCount:0,//派送失败
  packetlossCount:0,//快递丢包
  deliverytimeoutCount:0,//发货超时
  paytimeoutCountL:0,//付款超时
  buyercanceledCount:0,//买家取消
  otherCount:0,//其它原因
  T:null,
  management01:0,
  management02:0,
  management03:0,
  printedUrl:[],
  auditOrder_success:[],
  auditOrder_error:[],
  ttp:false,
  autoReives:[],
  allOrder:[],//卖家帐号下shopee所有商店订单
  allCount:0,
  successGetData:0,
  canceldingdang:0,
  tuhuodingdang:0,
  senqingquxiao:0,
  categoryorderlist:[],
  Logistics:[],
  printhistoryrecord:[],
  printhistorycount:0,
  categoryordertotal:0,
  times:0,
  goodsType:null,
  flashPage:false,
  Maplist:[],
  buttonList:[],
  activeList:[],
  orderList:[],
  buttonMapList:[],
  toSellerProcess:0,
  toStoreProcess:0,
  storeItemsData:[]
  
  
})

const getters = {}

const actions = {
	
	getStoreItemInfo({state},payload) {
		order
		.getstoreitembyid(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('5555111',res.data)
				state.storeItemsData=res.data

				state.allOrder.forEach(k => {
					k.items.forEach(p => {
						if(!p.storeItem || p.storeItem== null || p.storeItem== undefined){
							// console.log(this.storeItemsData)
							p.storeItem=state.storeItemsData[p.itemId + '_' + p.variationId]
						}
					})
				})
			}
		})
		
	},
	//重新加载订单
	reloadOrder({state},payload) {
		order
		.reloadOrder(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('重新加载订单',res.data)
				Message({
					message: '订单加载中，数据会在10-15s左右同步完成！',
					type: 'success'
				})
			}
		})
		
	},
	//获取待审核的订单信息 ---高级查询
	getUnaditorOrder({state,commit,dispatch},payload) {
		const p =new Promise((resolve) => {
			order
		.getUnaditorOrder(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('获取待审核订单-高级查询',res.data)
				
				state.orderList=res.data
				let list2=[]
				state.buttonList = [];
				for (let i = 0; i < 3; i++) {
					state.buttonList.push(new Map())
					state.activeList.push('all')
				}
				if(!res.data.length){
					state.buttonMapList=[]
					state.buttonList=[]
					resolve(state.buttonMapList)
					return
				}


				//选择店铺
				state.orderList.forEach((order) => {
					order.shipByDateCopy=order.shipByDate
					order.flagInfo={flagId:order.flagId,desc:null}
					order.shipByDate=utils.renderTimeDate(order.shipByDate)

					order.items.forEach(k => {
						let ttp=list2.find(p => p.itemId == k.itemId && p.variationId == k.variationId)
						if(ttp == undefined){
							list2.push({
								itemId:k.itemId,
								variationId:k.variationId,
							})
						}
							
					})
					let shopIdMap = state.buttonList[0];
					let shopIdList = shopIdMap.get(order.shopId);
					if (shopIdList == null || shopIdList == "undifined") {
						shopIdList = [];
					}
					shopIdList.push(order);
					shopIdMap.set(order.shopId, shopIdList)
					state.buttonList[0] = shopIdMap;
				})

				console.log('list2',list2)
								
				dispatch('getstoreitembyid',list2)
				let list = [];
				let flag = true;
				let firstShopId=0;
				state.buttonList[0].forEach((value, key) => {
					if(firstShopId==0){
						firstShopId=key
					}
					let active = (key == firstShopId)
					if (active == true) {
						flag = false
					}
					list.push({
						'key': key,
						'value': value,
						'isActive': active
					})
				})
				if (flag) {
					list[0].isActive = true;
				}
				state.buttonMapList.push(list);
				console.log('asfdsafga', state.buttonList);
				console.log('asfdsafga', state.buttonMapList);
				resolve(state.buttonMapList)
				
				commit(GET_TTP_PPO,{
					orders: state.buttonList[0].get(firstShopId),
					index: 0
				})
				
				
				
			}
		})
		})
		return p
		
		
	},
	
	//仓库端获取每个订单的货物类型
	getGoodsTypeByStore({state},payload) {
		order
		.getGoodsTypeByStore(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('goodstype',res.data)
				state.goodsType=res.data
			}
		})
		
	},
	//重新生成PDF
	regeneratePDF({state},payload) {
		order
		.regeneratePDF(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('面单数据更新成功',res.data)
				state.printedUrl.forEach((p,index)=> {
					if(p.options.id == res.data.id) {
						state.printedUrl[index].url01=JSON.parse(res.data.url)
					}
				})
				console.log('hfkjv',state.printedUrl)
				Message({
					message: '面单数据更新成功,请重新打印',
					type: 'success'
				})
			}else{
				Message({
					message: res.msg,
					type: 'error'
				})
			}
		})
		
	},	
	//填写物流单
	fill_In_logisticsNumber({state},payload) {
		order
		.logisticsNumber(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('提交物流信息',res.data)
			}else{
				Message({
					message: res.msg,
					type: 'error'
				})
			}
		})
		
	},	
	//获取仓库产品
	getstoreitembyid({state},payload) {
		order
		.getstoreitembyid(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('ppoimhhvn',res.data)
				state.storeItemsData=res.data
			}
		})
	},
	
	
	getShopAllItems({state},payload) {
		mygoods
		.getShopAllItems(payload)
		.then(res => {
			if(res.code === 200) {
				let arr=res.data.items.map(p => {
					return {
						main:p,
						children:[]
					}
				
					
				})
				
				for(let i=0;i<arr.length;i++) {
					for(let j=i+1;j<arr.length;j++) {
						if(arr[i].main.cusCode !== 0) {
							if(arr[i].main.cusCode === arr[j].main.cusCode) {
								arr.splice(j,1)
								j--
							}
						}
						
					}
				}
				
				
				res.data.items.forEach(p => {
					arr.forEach(k => {
						if(k.main.cusCode !== 0) {
							if(p.cusCode == k.main.cusCode  && p.itemId !== k.main.itemId) {
								k.children.push(p)
							}
						}
						
					})
				})
				
				state.categoryorderlist=arr
				state.categoryordertotal=res.data.count
				console.log(arr)
				// dispatch('getStoreItemCount',payload)
			}
		})
	},
	
	
	deleteorderpackage({state},payload) {
		order
		.deleteorderpackage(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('删除代打包的运单号',res.data)
				Message({
					message: '成功删除',
					type: 'success'
				})
			}
		})
	},
	storeReceived({state},payload) {
		order
		.storeReceived(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('仓库收到代打包运单',res.data)
				Message({
					message: '确认收货成功',
					type: 'success'
				})
			}
		})
	},
	//根据打包运单号查询订单
	getOrderByPackageTrackingCode({state,dispatch},payload) {
		order
		.getOrderByPackageTrackingCode(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('根据打包运单号查询订单',res.data)
				state.ax_auditedOrderList=res.data
				console.log(payload)
				let item={}
				if(res.data[0].orderPackages) {
					res.data[0].orderPackages.forEach(p => {
						if(p.trackingCode === payload.trackingCode) {
							item=p
						}
					})
					
					dispatch('storeReceived',item)
					// setTimeout(() => {
					// 	dispatch('storeReceived',item)
					// },1000)
				}
				
			}
		})
	},
	//新增代打包运单号
	addOrderPackage({state},payload) {
		order
		.addOrderPackage(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('代打印运单号',res.data)
			}
		})
	},
	//获取订单分类
	getSpeciesOrder({state},payload) {
		order
		.getSpeciesOrder(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('订单商品种类',res.data)
				let arr=res.data.items.map(p => {
					return {
						main:p,
						children:[]
					}	
				})
				
				for(let i=0;i<arr.length;i++) {
					for(let j=i+1;j<arr.length;j++) {
						if(arr[i].main.cusCode !== 0) {
							if(arr[i].main.cusCode === arr[j].main.cusCode) {
								arr.splice(j,1)
								j--
							}
						}
						
					}
				}
				res.data.items.forEach(p => {
					arr.forEach(k => {
						if(k.main.cusCode !== 0) {
							if(p.cusCode == k.main.cusCode  && p.itemId !== k.main.itemId) {
								k.children.push(p)
							}
						}
					})
				})
				console.log(arr)
				state.categoryorderlist=arr
				state.categoryordertotal=res.data.count
				// console.log('去重后的数据',arr)
			}
		})
	},
	//pick_up 批量生成运单号
	getInitOrderBypickup({commit,dispatch},payload) {
		order
		.getInitOrderBypickup(payload)
		.then(res => {
			if(res.code === 200) {
				dispatch('getTrackIngNoByOrdersn',payload)
			}
		})
	},
	//dropp_off 批量生成运单号
	getInitOrderBydropoff({commit, dispatch},payload) {
		order
		.getInitOrderBydropoff(payload)
		.then(res => {
			if(res.code === 200) {
				console.log(9999)
				dispatch('getTrackIngNoByOrdersn',payload)
			}
		})
	},
	//用订单号轮询查找运单号，如果找到就返回运单号
	getTrackIngNoByOrdersn({state,commit,dispatch},payload) {
			order
			.getTrackIngNoByOrdersn(payload)
			.then(res => {
				// console.log('times',payload.times)
				// if(payload.times=='undefined'){
				// 	payload.$set('times',0) ;
				// }
				// console.log('newtimes',payload.times)
				if(res.code === 200) {
					if(res.data) {
						commit(ININ_TRACKING_NO,{ordersn:payload.ordersn,trackingNo:res.data})
						return
					}else{
						state.times++
						console.log(state.times)
						if(state.times%30==0){
							//重新调用生成运单号
							state.times=0
							console.log('30次了，还没有返回运单号')
							if(!payload.pickup) {
								dispatch('getInitOrderBypickup',payload)
							}else{
								dispatch('getInitOrderBydropoff',payload)
							}
						}else{
							console.log(('还没有生成订单号'))
							dispatch('getTrackIngNoByOrdersn',payload)
						}
					}
				}
			})
		
		
	},
	//订单号查找订单
	getOrdersBytrickNo({commit, state,dispatch},payload) {
		const p =new Promise((resolve) => {
			order
			.queryAllOrder(payload)
			.then(res => {
				if(res.code === 200) {
					resolve(res.data)
					console.log('picking',res.data)
					res.data.orders.forEach(p => {
						state.picklist.push(p)
					})
					
				}
				
			})
		})
		return  p
	},
	//订单号查找订单
	getOrdersBytrickNo_return({commit},payload) {
		order
		.getOrdersBytrickNo_return(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('问题单类型',res.data)
				if(payload.type === 1) {//查找待审核订单
					commit(GET_UNPROCESS_ORDER,res.data)
				}else if(payload.type === 9) {//查找有问题的订单
					if(res.data.orders[0].returnsn) {
						commit(GET_RETURN_ORDER,res.data)
					}else{
						commit(GET_QUESTION_ORDER,res.data)
					}
				}else if(payload.type === 5){//查找已发货的订单
					commit(GET_COMPLETEED_ORDER,res.data)
				}else if(payload.type === 2){//查找待处理订单
				    commit(GET_DEAL_ORDER,res.data)
				}else if(payload.type === -1) {
					commit(SET_PICKING_LIST,res.data)
					commit(SET_ITEM_CHECKED_FALSE)
				}
			}
		})
	},
	// //获取订单总数
	// getOrderCountTotal({commit,state},payload){
	// 	console.log(payload)
	// 	api
	// 	.getOrderCountTotal(payload) 
	// 	.then(res => {
	// 		if(res.code === 200) {
	// 		   if(payload.type === 0) {
	// 			   state.allCount=res.data
	// 		   }else if(payload.type === 1) {//待审核订单总数1
	// 				commit(PENDING_TOTAL_COUNT,res.data)
	// 			}else if(payload.type === 5) {//待处理订单总数1
	// 				commit(UNPROCESS_TOTAL_COUNT,res.data)
	// 			}else if(payload.type===2) {//待处理全部订单总数
	// 			    commit(UNPROCESS_TOTAL_COUNT,res.data)
	// 				// commit(SHIPPED_TOTAL_COUNT,res.data)
	// 			}else if(payload.type === 13){//取消订单总数--
	// 				commit(PROBLEM_TOTAL_COUNT,res.data)
	// 			}else if(payload.type === 19){//退货订单总数
	// 				commit(GET_RETURN_CHIRD_TOTAL_18,res.data)
	// 			}else if(payload.type === 10) {//申请取消订单总数--
	// 				commit(IN_CANCEL_TOTAL_ORDER,res.data)
	// 			}else if(payload.type === 3) {//未打印1
	// 				commit(UNPROCESS_TOTAL_COUNT,res.data)
	// 			}else if(payload.type === 4) {//已打印1
	// 				commit(UNPROCESS_TOTAL_COUNT,res.data)
	// 			}else if(payload.type===6) {//已发货订单总数
	// 				commit(SHIPPED_TOTAL_COUNT,res.data)
	// 			}else if(payload.type===7) {//已发货订单总数
	// 				commit(SHIPPED_TOTAL_COUNT,res.data)
	// 			}else if(payload.type===9) {//已发货订单总数
	// 				commit(SHIPPED_TOTAL_COUNT,res.data)
	// 			}else if(payload.type===10) {//已发货订单总数
	// 				commit(SHIPPED_TOTAL_COUNT,res.data)
	// 			}else if(payload.type===8) {//已发货订单总数
	// 				commit(SHIPPED_TOTAL_COUNT,res.data)
	// 			}else if(payload.type===23) {//已发货订单总数
	// 				commit(UNPROCESS_TOTAL_COUNT,res.data)
	// 			}else if(payload.type === 14) {//退货订单总数--
	// 				commit(RETURN_TOTAL_ORDER,res.data)
	// 			}else if(payload.type === 20) {
	// 				commit(GET_RETURN_CHIRD_TOTAL_23,res.data)
	// 			}else if(payload.type === 18) {
	// 				commit(GET_RETURN_CHIRD_TOTAL_22,res.data)
	// 			}else if(payload.type === 15) { //申请中
	// 				commit(GET_RETURN_CHIRD_TOTAL_14,res.data)
	// 			}else if(payload.type === 15) {
	// 				commit(GET_RETURN_CHIRD_TOTAL_17,res.data)
	// 			}else if(payload.type === 16) { //已接受
	// 				commit(GET_RETURN_CHIRD_TOTAL_15,res.data)
	// 			}else if(payload.type === 17) {//取消退货
	// 				commit(GET_RETURN_CHIRD_TOTAL_16,res.data)
	// 			}else if(payload.type === 210) {
	// 				commit(GET_RETURN_CHIRD_TOTAL_22,res.data)
	// 			}else if(payload.type === 22) {//已退款--
	// 				commit(GET_RETURN_CHIRD_TOTAL_21,res.data)
	// 			}else if(payload.type === 21) {
	// 				commit(GET_RETURN_CHIRD_TOTAL_20,res.data)
	// 			}else if(payload.type === 24) {
	// 				commit(GET_CANCEL_TOTAL_24,res.data)
	// 			}else if(payload.type === 25) {
	// 				commit(GET_CANCEL_TOTAL_25,res.data)
	// 			}else if(payload.type === 26) {
	// 				commit(GET_CANCEL_TOTAL_26,res.data)
	// 			}else if(payload.type === 27) {
	// 				commit(GET_CANCEL_TOTAL_27,res.data)
	// 			}else if(payload.type === 28) {
	// 				commit(GET_CANCEL_TOTAL_28,res.data)
	// 			}else if(payload.type === 29) {
	// 				commit(GET_CANCEL_TOTAL_29,res.data)
	// 			}else{
	// 				commit(GET_RETURN_MANAGEMTNT,{type:payload.type,num:res.data})
	// 			}
				
	// 		}
	// 	})
	// },
	//获取所有店铺待审核的订单
	getPendingOrder({state,commit,dispatch},payload) {
		api
		.getOrderList(payload)
		.then(res => {
			if(res.code === 200) {	
				console.log( "所有商店待审核订单",res.data)
				let list2=[]
				state.Maplist=[]
				for(let i=0; i<3 ;i++) {
					state.Maplist.push(new Map())
				}

				res.data.orders.forEach(p => {
					p.items.forEach(k => {
						list2.push({
								itemId:k.itemId,
								variationId:k.variationId
						})
						
					})

					p.shipByDate=utils.renderTimeDate(p.shipByDate)
					let list=[]
					list=state.Maplist[0].get(p.shipByDate)
					if(list === null || list === undefined) {
						list=[]
					}
					list.push(p)
					state.Maplist[0].set(p.shipByDate,list)
				})
				
				console.log()
				
				
				commit(GET_UNPROCESS_ORDER,res.data) //筛选待审核订单
				
				res.data.orders.forEach(p => {
					p.items.forEach(k => {
						list.push({
								itemId:k.itemId,
								variationId:k.variationId
						})
						
					})
				})
				
				dispatch('getstoreitembyid',list2)
				
				
				
			}
		})
	},

	//获取所有店铺待处理的订单
	getUnprocessOrder({commit,dispatch,state},payload) {
		api
		.getOrderList(payload)
		.then(res => {
			if(res.code === 200) {	
				console.log( "所有商店待处理订单",res.data)
				commit(GET_DEAL_ORDER,res.data) //筛选待处理的订单
				res.data.orders.forEach(p => {
					p.items.forEach(k => {
						dispatch('getstoreitembyid',{
							type:payload.type,
							itemId:k.itemId,
							variationId:k.variationId
						})
					})
				})
				state.successGetData++
			}
		})
	},
	
	//获取所有店铺已发货的订单
	getAllorder({commit,state, dispatch},payload) {
		api
		.getOrderList(payload)
		.then(res => {
			if(res.code === 200) {	
				console.log( "卖家帐号下所有订单",res.data)
				res.data.orders.forEach(item => {
					item.checked=true
				})
				state.allOrder=res.data.orders
				state.allCount=res.data.count
			}
		})
	},

//获取卖家所有订单
	queryAllOrder({commit,state, dispatch},payload) {
		const p =new Promise((resolve) => {
			order
			.getDistrustOrders(payload)
			.then(res => {
				resolve(res)
				console.log('----1---')
				console.log(res)
				if(res.code === 200) {	
					console.log( "获取卖家所有订单152",res.data)
				    let arr=[]
					res.data.orders.forEach(p => {
						p.checked=false
						p.items.forEach(k => [
							arr.push({
								itemId:k.itemId,
								variationId:k.variationId,
							})
						])
					})
					// dispatch('getStoreItemInfo',arr)
					state.allOrder=res.data.orders
					state.allCount=res.data.count
					
				}else{
					Message({
						message: res.msg,
						type: 'warning'
					})
				}
			})
		})
		return  p
		
	},
	
	
	//获取所有店铺已发货的订单
	getShippedOrder({commit,dispatch},payload) {
		api
		.getOrderList(payload)
		.then(res => {
			if(res.code === 200) {	
				console.log( "所有商店已发货订单",res.data)
				commit(GET_COMPLETEED_ORDER,res.data) //筛选已处理的订单
				// dispatch('getOrderCountTotal',{
				// 	shopId:payload.shopId,
				// 	type:payload.type,
				// 	userId:payload.userId,
				// })
			}
		})
	},

	queryReturnOrderNum({state, commit,dispatch},payload) {
		
		// order
		// .queryReturnOrderNum(payload)
		// .then(res => {
		// 	if(res.code === 200) {	
		// 		console.log('退货订单处理数量',res.data)
		// 		state.toSellerProcess=res.data
		// 	}
		// })
	},
	
	//获取所有店铺有问题的订单
	getProblemorder({state, commit,dispatch},payload) {
		api
		.getOrderList(payload)
		.then(res => {
			if(res.code === 200) {	
				commit(GET_QUESTION_ORDER,res.data)
				
				res.data.otherCount.forEach(p => {
					if(p.type == 30) {
						state.toSellerProcess=p.count
					}
					
					if(p.type == 31) {
						state.toStoreProcess=p.count
					}
					
				})
				console.log(state.toSellerProcess)
				console.log("问题订单",res.data)
			}
		})
	},

	//审核订单
    auditOrder({state, commit},payload) {
		api
		.auditOrder(payload.payload)
		.then(res => {
			if(res.code === 200) {
				console.log('多单审核',res.data)
		
				res.data.success.forEach(p => {
					p.service=false
				})
				res.data.error.forEach(p => {
					p.service=false
				})
				state.auditOrder_success=res.data.success
				state.auditOrder_error=res.data.error
				
				
				
			}
		})
	},
	
	//打印订单
	getPrintOrder({state, commit},payload){
		api
		.getPrintOrder(payload) 
		.then(res => {
			if(res.code === 200) {
				console.log('面单打印数据',res.data)
				let urlList=[]
				res.data.forEach( p => {
					p.url=JSON.parse(p.url)
					p.ordersn=JSON.parse(p.ordersn)
					p.url.forEach(k => {
						urlList.push(k)
					})
				})
				console.log(urlList)
				let aap=[]
				urlList.forEach(p => {
					
					res.data.forEach( k => {
						// k.ordersn=JSON.parse(k.ordersn)
						k.url.forEach( j => {
							if(j == p) {
								let oop=k.createTime.slice(0,k.createTime.indexOf("T"))
								let  ttp=oop.split("-")
								console.log(ttp)
								aap.push({
									url01:p,
									time:ttp,
									options:k
								})
							}
						})
					})
				})
				console.log(aap)
					aap.forEach(p => {
						p.isPrint=false
						p.isPrintPicklist=false
					})
					state.printedUrl=aap
					// console.log('返回的面单URL',arr)
					
					
				}else{
					Message({
						message: res.msg,
						type: 'error'
					})
					commit(SUCCESS_GET_DATA)

				
	
			}
		})
	},
	//同步订单状态
	updatShopAllOrders({commit},payload) {
		 order
		.updatShopAllOrders(payload.payload) 
		.then(res => {
			if(res.code === 200) {
				
				Message({
					message: '订单已同步完成，请刷新当前页！',
					type: 'success'
				})
			}
		})
	},
	//查看物流
	viewLogistics({commit},payload) {
		order
		.viewLogistics(payload) 
		.then(res => {
			if(res.code === 200) {
				console.log(res.data)
				commit(GET_LOGISTICS_INFO,res.data.response)
			}
		})
	},
	
	cancelReview({commit},payload) {
		const p =new Promise((resolve) => {
			order
			.cancelReview(payload.payload) 
			.then(res => {
				if(res.code === 200) {
					Message({
						message: payload.text,
						type: 'success'
					})
					resolve('success')
					commit(DELET_UNPROCESS_ORDER,payload.payload)
				}
			})
		})

		return p
		
	},
	
	receiveReturn({commit},payload) {
		order
		.receiveReturn(payload) 
		.then(res => {
			if(res.code === 200) {
				Message({
					message: '成功提交收货信息',
					type: 'success'
				})
				console.log('成功提交收货信息',res.data)
			}
		})
	},
	
	
	sellerComfirm({commit},payload) {
		order
		.sellerComfirm(payload) 
		.then(res => {
			if(res.code === 200) {
				Message({
					message: '卖家成功确认',
					type: 'success'
				})
				console.log('卖家成功确认',res.data)
			}
		})
	},
	
	storeComfirm({commit},payload) {
		order
		.storeComfirm(payload) 
		.then(res => {
			if(res.code === 200) {
				Message({
					message: '仓库成功确认',
					type: 'success'
				})
				console.log('卖家成功确认',res.data)
			}
		})
	},
	
	
	reviewOrder({state,commit,dispatch},payload) {
		const p =new Promise((resolve) => {
			order
			.reviewOrder(payload) 
			.then(res => {
				if(res.code === 200) {
					
					state.auditOrder_success=[]
					state.auditOrder_error=[]
					state.flashPage=true
					resolve(res)
				}else{
					Message({
						message: res.msg,
						type: 'error'
					})
				}
			})
		})

		return p
		
	},


	reviewOrderCopy({state,commit,dispatch},payload) {
		const p =new Promise((resolve) => {
			order
			.reviewOrder(payload) 
			.then(res => {
				if(res.code === 200) {
					Message({
						message: '订单审核成功',
						type: 'success'
					})
					let list=state.buttonMapList[2].find(item => item.isActive).value
					list=list.filter(p => {
						let arrlist=payload.map(v => v.ordersn)
						return !arrlist.includes(p.orderId)
					})
					state.buttonMapList[2].find(item => item.isActive).value=list
					resolve(200)
				}
			})
		})

		return p
	},
	
	getAutoreviewrules({state,commit},payload) {
		order
		.getAutoreviewrules(payload) 
		.then(res => {
			if(res.code === 200) {
				console.log('获取自动审核',res.data)
				state.autoReives=res.data
			}
		})
	},
	//添加自动审核
	addAutoreviewrules({dispatch,commit},payload) {
		order
		.addAutoreviewrules(payload) 
		.then(res => {
			if(res.code === 200) {
				Message({
					message: '设置成功！',
					type: 'success'
				})
				console.log('添加自动审核',res.data)
				dispatch("getAutoreviewrules",{userId:payload.userId})
			}
		})
	},
	
	//删除自动审核
	
	delAutoreviewrules({commit},payload) {
		order
		.delAutoreviewrules(payload) 
		.then(res => {
			if(res.code === 200) {
				Message({
					message: '已关闭自动审核',
					type: 'success'
				})
				console.log('删除自动审核',res.data)
			}
		})
	},

	//根据商品获取订单
	getGoodsOrder({state},payload) {
		order
		.getGoodsOrder(payload) 
		.then(res => {
			if(res.code === 200) {
				console.log('订单',res.data)
				console.log(payload.type)
					// state.allOrder=res.data.orders
					// state.allCount=res.data.count
				if(payload.type === 2 || payload.type === 3 || payload.type === 4 || payload.type === 5) {
					state.ax_auditedOrderList=res.data.orders
					state.unprocessedorderCounts=res.data.count
				}else if(payload.type === 1){
					console.log('待审核订单分类拣货',res.data)
					state.ax_unprocessOrder=res.data.orders
					state.pendingorderCounts=res.data.count
				}else {
					state.allOrder=res.data.orders
					state.allCount=res.data.count
				}
			}
		})
	},
	
	//获取物流
	getLogistics({state},payload){
		order
		.getLogistics(payload) 
		.then(res => {
			if(res.code === 200) {
				console.log('物流种类',res.data)
				state.Logistics=res.data.map(p => {
					return {
						value:p.name ,
						label:p.name+ '('+ p.count + ')'
					}
				})
				
				state.Logistics.unshift({
					value:null,
					label:i18n.t('unprocessedorder').logistic
				})
				
			}
		})
	},
	//增加打印次数
	addPrintTimes({state},payload){
		order
		.addPrintTimes(payload) 
		.then(res => {
			if(res.code === 200) {
				console.log('增加打印次数',res.data)
			}
		})
	},
	//获取打印订单的历史纪录
	getPrintSheetHistory({state},payload){
		console.log(payload)
		order
		.getPrintSheetHistory(payload) 
		.then(res => {
			if(res.code === 200) {
				console.log('打印订单的历史纪录',res.data)
				if(res.data.urls) {
					res.data.urls.forEach(p => {
						let ttp=p.createTime.slice(0,p.createTime.indexOf("T"))
						let  ccp=ttp.split("-")
						p.ordersn=JSON.parse(p.ordersn)
						p.tip=ccp
					})
					state.printhistoryrecord=res.data.urls.filter(p => {
						if(p.updateTime) {
							return p
						}
					})
					state.printhistorycount=state.printhistoryrecord.length
				}
				
			}
		})
	},
	
	getPrintTogether({state},payload){
		order
		.getPrintTogether(payload) 
		.then(res => {
			if(res.code === 200) {
				console.log('合并打印',res.data)
				window.open(res.data.url)
			}else{
				Message({
					message: '合并打印出错，请稍后再试！',
					type: 'error'
				})
			}
		})
	},


}

const mutations = {
	[SET_FLAGS]: (state,obj) => {
		console.log(obj)
		let ordersId=obj.arr
		state.orderList.forEach(p => {
			ordersId.forEach(k => {
				if(p.orderId == k){
					
					console.log(564152)
					p.flagId=obj.id
					p.flagInfo.flagId=obj.id
					p.flagInfo.desc=obj.desc
					console.log(p)
				}
			})
		})
		
		
		
		
		
		
		
	},
	[SET_ORDERLIST_NULL]: (state) => {
		state.allorderList=[]
		state.unprocessOrder=[]
		state.auditOrder_success=[]
		state.auditOrder_error=[]
		
	},
	//在所有订单获取待审核的订单
	[GET_UNPROCESS_ORDER]: (state,data) =>{
		
		console.log(state.Maplist)
	   data.orders.forEach((item) => {
		   item.checked=false
	   })
	   
	   
	   
		state.ax_unprocessOrder=data.orders
		state.pendingorderCounts=data.count
	},
	
	
	//获取所有订单中待处理的订单
	[GET_DEAL_ORDER] : (state,data) => {
		data.orders.filter((item) => {
		    return item.checked=false
		})
		state.ax_auditedOrderList=data.orders
		state.unprocessedorderCounts=data.count
	},
	//在所有订单获取已发货的订单
	[GET_COMPLETEED_ORDER] : (state,data) => {
		state.ax_dealOrder=data.orders
		state.shippedorderCounts=data.count
		
	},
	//在所有订单中获取问题订单
	[GET_QUESTION_ORDER]: (state, data)  => {
		console.log(5555)
			state.ax_quesetionOrderList=data.orders
			data.otherCount.forEach(p => {
				if(p.type === 30) {
					state.management01=p.count
				}else if(p.type === 31){
					state.management02=p.count
				}else if(p.type === 32){
					state.management03=p.count
				}else if(p.type === 24){
					state.deliverfailedCount=p.count
				}else if(p.type === 25){
					state.packetlossCount=p.count
				}else if(p.type === 26){
					state.deliverytimeoutCount=p.count
				}else if(p.type === 27){
					state.paytimeoutCountL=p.count
				}else if(p.type === 28){
					state.buyercanceledCount=p.count
				}else if(p.type === 29){
					state.otherCount=p.count
				}else if(p.type === 15){
					state.applicationCounts=p.count
				}else if(p.type === 16){
					state.acceptedCounts=p.count
				}else if(p.type === 17){
					state.cancelCounts=p.count
				}else if(p.type === 19){
					state.returnCounts=p.count
				}else if(p.type === 23){
					state.rulingCounts=p.count
				}else if(p.type === 18){
					state.disputeCounts=p.count
				}else if(p.type === 22){
					state.returnedCounts=p.count
				}else if(p.type === 21){
					state.closedCounts=p.count
				}else if(p.type === 13){
					state.canceldingdang=p.count
				}else if(p.type === 14){
					state.tuhuodingdang=p.count
				}else if(p.type===10) {
					state.senqingquxiao=p.count
				}
			})
	},
	//获取所有的订单
	[SET_ORDER_LIST]: (state,data) =>{
	   state.allorderList=data
	},
	
	//待处理订单查找
	[GO_TO_SEARCH]:(state,data) =>{
		let arr=[]
		for (var i = 0; i < data.length; i++) {
		          for (var j = 0; j < state.auditedOrderList.length; j++) {
		            if (data[i] === state.auditedOrderList[j].ordersn) {
		              arr.push(state.auditedOrderList[j])
		              break;
		            }
		          }
		        }
		
		console.log('多单查找',arr)
		if(!arr.length) {
			alert('暂无当前查找的订单号！')
			return
		}else{
			state.ax_auditedOrderList=arr
		}
		
		
	},

	//已处理订单查找
	[GO_TO_SEARCH_DEALOURDER]:(state,data) =>{
		let arr=[]
		for (var i = 0; i < data.length; i++) {
		          for (var j = 0; j < state.dealOrder.length; j++) {
		            if (data[i] === state.dealOrder[j].ordersn) {
		              arr.push(state.dealOrder[j])
		              break;
		            }
		          }
		        }
		
		console.log('多单查找',arr)
		if(!arr.length) {
			alert('暂无当前查找的订单号！')
			return
		}else{
			state.ax_dealOrder=arr
		}
		
		
	},
	//待审核订单查找
	[GO_TO_SEARCH_PENDING]:(state,data) =>{
		
		let arr=[]
		for (var i = 0; i < data.length; i++) {
		          for (var j = 0; j < state.unprocessOrder.length; j++) {
		            if (data[i] === state.unprocessOrder[j].ordersn) {
		              arr.push(state.unprocessOrder[j])
		              break;
		            }
		          }
		        }
		
		console.log('多单查找',arr)
		if(!arr.length) {
			alert('暂无当前查找的订单号！')
			return
		}else{
			state.ax_unprocessOrder=arr
		}
	},
	
	//问题订单查找
	[GO_TO_SEARCH_QUESTION]:(state,data) =>{
		
		let arr=[]
		for (var i = 0; i < data.length; i++) {
		          for (var j = 0; j < state.quesetionOrderList.length; j++) {
		            if (data[i] === state.quesetionOrderList[j].ordersn) {
		              arr.push(state.quesetionOrderList[j])
		              break;
		            }
		          }
		        }
		
		console.log('多单查找',arr)
		if(!arr.length) {
			alert('暂无当前查找的订单号！')
			return
		}else{
			state.ax_quesetionOrderList=arr
		}
	},
	
	//待审核订单状态筛选功能
	[ALL_ORDERS]: (state,data) =>{
		
		if(data === 'all') {
			state.ax_unprocessOrder=state.unprocessOrder
		}else if(data === 'UNPAID'){ //未付款的订单
		
			let arr=state.unprocessOrder.filter(item => {
				return item.orderStatus === data
			})
			state.ax_unprocessOrder=arr
		}
		else if(data === 'READY_TO_SHIP'){ //待发货的订单
			let arr=state.unprocessOrder.filter(item => {
				return item.orderStatus === data
			})
			
			state.ax_unprocessOrder=arr
		}else if(data === 'TO_CONFIRM_RECEIVE'){ //待确认的订单
			let arr=state.unprocessOrder.filter(item => {
				return item.orderStatus === data
			})

			state.ax_unprocessOrder=arr
		}
		else if(data === 'COMPLETED'){ //已完成的订单
			let arr=state.unprocessOrder.filter(item => {
				return item.orderStatus === data
			})

			state.ax_unprocessOrder=arr
		}
		else if(data === 'IN_CANCEL'){ //取消的订单
			let arr=state.unprocessOrder.filter(item => {
				return item.orderStatus === data
			})

			state.ax_unprocessOrder=arr
		}else if(data === 'TO_RETURN'){ //退货的订单
			let arr=state.unprocessOrder.filter(item => {
				return item.orderStatus === data
			})
	
			state.ax_unprocessOrder=arr
		}
		
	
	},
	
	//问题订单筛选
	[QUESTION_ORDER_CHOOSE]: (state,data) =>{
		
		if(data === 'all') {
			state.ax_quesetionOrderList=state.quesetionOrderList
		}else if(data === 'CANCELLED'){ //筛选已取消订单
		
			let arr=state.quesetionOrderList.filter(item => {
				return item.orderStatus === data
			})
			
			state.ax_quesetionOrderList=arr
		}else if(data === 'TO_RETURN'){ //筛选退货订单
			let arr=state.quesetionOrderList.filter(item => {
				return item.orderStatus === data
			})
			
			state.ax_quesetionOrderList=arr
		}else if(data === 'IN_CANCEL'){ //筛选正在申请取消订单
			let arr=state.quesetionOrderList.filter(item => {
				return item.orderStatus === data
			})
	
			state.ax_quesetionOrderList=arr
		}
		else if(data === 'COMPLETED'){ //已完成的订单
			let arr=state.unprocessOrder.filter(item => {
				return item.orderStatus === data
			})
	
			state.ax_unprocessOrder=arr
		}
		else if(data === 'IN_CANCEL'){ //取消的订单
			let arr=state.unprocessOrder.filter(item => {
				return item.orderStatus === data
			})
	
			state.ax_unprocessOrder=arr
		}else if(data === 'TO_RETURN'){ //退货的订单
			let arr=state.unprocessOrder.filter(item => {
				return item.orderStatus === data
			})
	
			state.ax_unprocessOrder=arr
		}
		
	
	},
	
	
	//踢除待审核里已审核过的订单
	[DELET_UNPROCESS_ORDER]: (state,data)=> {
		console.log(data)
         for (var j = 0; j < state.ax_unprocessOrder.length; j++) {
			 if (data.ordersn === state.ax_unprocessOrder[j].ordersn) {
			   state.ax_unprocessOrder.splice(j,1)
			   break;
			 }
           }
		
				
		for (var i = 0; i < data.length; i++) {
		          for (var j = 0; j < state.ax_auditedOrderList.length; j++) {
		            if (data[i].ordersn === state.ax_auditedOrderList[j].ordersn) {
		              state.ax_auditedOrderList.splice(j,1)
		              break;
		            }
		          }
		        }		
				
		
	
	},
	//待审核店铺筛选
	[CHOOSE_SHOPID]:(state,data) => {
		if(data === '123') {
			state.ax_unprocessOrder=state.unprocessOrder
		}else{
			let arr=state.unprocessOrder.filter(item => {
				return item.shop.shopId === data
			})
			
			state.ax_unprocessOrder=arr
		}
	},
	//待处理订单店铺筛选
	[CHOOSE_SHOPID_TTP]:(state,data) => {
		if(data === '123') {
			state.ax_auditedOrderList=state.auditedOrderList
		}else{
			let arr=state.auditedOrderList.filter(item => {
				return item.shop.shopId === data
			})
			
			state.ax_auditedOrderList=arr
		}
	},
	//已处理订单店铺筛选
	[CHOOSE_SHOPID_OOP]:(state,data) => {
		if(data === '123') {//全部订单状态
			state.ax_dealOrder=state.dealOrder
		}else{//根据传入data值,有两个值：TO_CONFIRM_RECEIVE，COMPLETED
			let arr=state.dealOrder.filter(item => {
				return item.shop.shopId === data
			})
			
			state.ax_dealOrder=arr
		}
	},
	//问题订单店铺筛选
	[CHOOSE_SHOPID]:(state,data) => {
		if(data === '123') {
			state.ax_quesetionOrderList=state.quesetionOrderList
		}else{
			let arr=state.quesetionOrderList.filter(item => {
				return item.shop.shopId === data
			})
			
			state.ax_quesetionOrderList=arr
		}
	},
	[SUCCESS_GET_DATA]:(state) => {
		state.isSuccess=false
	},
	
	[SUCCESS_GET_DATA_OPEN]:(state) => {
		state.isSuccess=true
	},
	
	//待审核订单总数
	[PENDING_TOTAL_COUNT]:(state,data) => {
		state.pendingorderCounts=data
	},
	//待处理订单总数
	[UNPROCESS_TOTAL_COUNT]:(state,data) => {
		state.unprocessedorderCounts=data
	},
	//已发货订单总数
	[SHIPPED_TOTAL_COUNT]:(state,data) => {
		state.shippedorderCounts=data
	},
	//取消订单总数
	[PROBLEM_TOTAL_COUNT]:(state,data) => {
		state.problemorderCounts=data
	},
	
	//退货订单总数
	[RETURN_TOTAL_ORDER]:(state,data) => {
		state.returnorderCounts=data
	},
	
	//申请取消订单总数
	[IN_CANCEL_TOTAL_ORDER]:(state,data) => {
		state.inCancelCounts=data
	},
	
	[GET_RETURN_CHIRD_TOTAL_14]: (state,data) => {
		state.applicationCounts=data
	},
	
	[GET_RETURN_CHIRD_TOTAL_15]: (state,data) => {
		state.acceptedCounts=data
	},
	
	[GET_RETURN_CHIRD_TOTAL_16]: (state,data) => {
		state.cancelCounts=data
	},
	[GET_RETURN_CHIRD_TOTAL_17]: (state,data) => {
		state.rulingCounts=data
	},
	[GET_RETURN_CHIRD_TOTAL_18]: (state,data) => {
		state.returnCounts=data
	},
	[GET_RETURN_CHIRD_TOTAL_20]: (state,data) => {
		state.closedCounts=data
	},
	[GET_RETURN_CHIRD_TOTAL_21]: (state,data) => {
		state.returnedCounts=data
	},
	[GET_RETURN_CHIRD_TOTAL_22]: (state,data) => {
		state.disputeCounts=data
	},
	[GET_RETURN_CHIRD_TOTAL_23]: (state,data) => {
		state.verifiedCounts=data
	},
	
	//点击批量打印后，将checked置为false
	[SET_ITEM_CHECKED_FALSE]: (state) => {
		let arr=[]
		arr = state.ax_auditedOrderList.filter(item => {
			return item.checked = false
		})
		console.log(arr)
		// state.ax_auditedOrderList=arr
	},
	
	
	[SET_ITEM_CHECKED_TRUE]: (state) => {
		let arr=[]
		arr = state.ax_auditedOrderList.filter(item => {
			return item.checked = true
		})
		console.log(arr)
		state.ax_auditedOrderList=arr
	},
	[SET_PICKING_LIST]: (state,data) =>{
		let num=0
		data.orders.forEach(p => {
			p.items.forEach(k => {
				num +=k.weight*k.variationQuantityPurchased
				p.weight=(num*1000).toFixed(0)
			})
		})
			state.picklist=data.orders
			console.log('拣货',state.picklist)
		},
		
		[SET_PICKING_NULL]: (state,data) =>{
				state.picklist=[]
				
		},
	//初始化运单号，给ax_auditedOrderList中的运单号重新赋值
	[ININ_TRACKING_NO]: (state,data) =>{

		let arr=state.ax_auditedOrderList
		for(let i=0;i<arr.length;i++) {
		   if(arr[i].ordersn === data.ordersn) {
			   arr[i].trackingNo = data.trackingNo
		   }
		}
		
		console.log('已更新运单号',arr)
		state.ax_auditedOrderList=arr
		
	},
	[GET_RETURN_ORDER]: (state,data) =>{
		state.ax_quesetionOrderList=data.orders
	},
	[GET_STORE_ALERDAY_PRINT]: (state,data) => {
		let arr = []
		let brr=[]
		state.ax_quesetionOrderList.forEach(item => {
			if(item.printfTime) {
				arr.push(item)
				state.ax_quesetionOrderList=arr
			}else{
				brr.push(item)
				state.ax_quesetionOrderList=brr
			}
		})	
	},
	[GET_LOGISTICS_INFO]: (state,data) => {
		state.LogisticsInfo=data
	},
	[GET_CANCEL_TOTAL_24]: (state,data) => {
		state.deliverfailedCount=data
	},
	[GET_CANCEL_TOTAL_25]: (state,data) => {
		state.packetlossCount=data
	},
	[GET_CANCEL_TOTAL_26]: (state,data) => {
		state.deliverytimeoutCount=data
	},
	[GET_CANCEL_TOTAL_27]: (state,data) => {
		state.paytimeoutCountL=data
	},
	[GET_CANCEL_TOTAL_28]: (state,data) => {
		state.buyercanceledCount=data
	},
	[GET_CANCEL_TOTAL_29]: (state,data) => {
		state.otherCount=data
	},
	[UPDATE_ALLORDERLIST]:(state,data) => {
		state.allOrder.forEach((p,index) => {
			if(p.orderId === data.orderId){
				
				state.allOrder.splice(index,1,data)
			}
		})

		console.log(state.allOrder)
	},

	[GET_RETURN_MANAGEMTNT]: (state,data) => {
		
		if(data.type === 30) {
			state.management01=data.num
		}else if(data.type === 31) {
			state.management02=data.num
		}else if(data.type === 32) {
			state.management03=data.num
		}
	},
	[GET_TTP]:(state,data) => {
		state.picklist=data
		console.log(state.picklist)
	},


	//筛选订单类型
	[GET_TTP_PPO]: (state, data) => {
	
		let index = data.index
		let orderList = [];
		if (index > 0) {
			orderList = state.buttonList[index].get(data.orders)
			console.log('orderList',orderList)
		} else {
			orderList = data.orders
		}
		
		for (let i = index + 1; i < 3; i++) {
			state.buttonList[i] = new Map();
			if (i > 0) {
				state.buttonList[i].set("all", orderList)
			}
		}
		console.log(orderList)
		if(orderList !== undefined){
			orderList.forEach((order) => {
				//最后发货
				if (index < 1) {
					let shipbydateMap = state.buttonList[1]
					let shipbydateList = shipbydateMap.get(order.shipByDate)
					if (shipbydateList == null || shipbydateList == "undifined") {
						shipbydateList = [];
					}
					shipbydateList.push(order);
					shipbydateMap.set(order.shipByDate, shipbydateList)
					
					state.buttonList[1] = shipbydateMap;
					
				}
				//sku状态
				if (index < 2) {
					let skuQuantityMap = state.buttonList[2]
					let skuQuantityList = skuQuantityMap.get(order.itemNum == 1 ? "oneSku" : "someSku")
					if (skuQuantityList == null || skuQuantityList == "undifined") {
						skuQuantityList = [];
					}
					skuQuantityList.push(order);
					skuQuantityMap.set(order.itemNum == 1 ? "oneSku" : "someSku", skuQuantityList)
					state.buttonList[2] = skuQuantityMap;
				}
			})

			console.log('buttonList1', state.buttonList);
			
			for (let j = 1; j < 3; j++) {
				state.buttonMapList[j] = null
			}
			state.buttonMapList.length = 1
			
			state.buttonList.forEach((map, i) => {
				let list = [];
				let flag = true;
				if (i != 0 ) {
					map.forEach((value, key) => {
						let active = (key == state.activeList[i])
						if (active == true) {
							flag = false
						}
						list.push({
							'key': key,
							'value': value,
							'isActive': active
						})
					})
					if (flag) {
						list[0].isActive = true;
					}
					state.buttonMapList.push(list);
				}
			
			})
			
			console.log('buttonMapList', state.buttonMapList);
			console.log('buttonList', state.buttonList);
		}else{
			state.buttonMapList.forEach((p,index) => {
				if(index >2){
					p=[{
						isActive:true,
						key:"all",
						value:[]
					}]
				}
			})
			
		}
	
	},

	
	
} 

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}